import { Box } from '@mui/system';
import styled from 'styled-components';

export const UpdateEntryModalWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 544px;
  width: 100%;
  padding: 32px;
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows[29]};
  background-color: ${({ theme }) => theme.palette.base.background};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  outline: none;
`;

export const EditEntry = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
`;

export const EditEntryForm = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;
  width: 100%;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const InputWrapperWithLabel = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ModalActions = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 100%;
`;

export const EntryActions = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 100%;
`;

export const LastModifiedContainer = styled(Box)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 4px;
  width: 100%;
  span {
    align-items: center;
    display: flex;
    color: ${({ theme }) => theme.palette.grey[500]};
    b {
      color: ${({ theme }) => theme.palette.grey[600]};
      font-weight: 500;
      margin-left: 2px;
    }
  }
  span:first-child svg {
    stroke: ${({ theme }) => theme.palette.grey[500]};
    margin-right: 8px;
  }
`;
